'use client'

import React, { useState } from 'react'
import { Dialog, DialogBackdrop, DialogPanel, DialogTitle } from '@headlessui/react'
import { ExclamationTriangleIcon } from '@heroicons/react/24/outline'

export default function ConfirmationModal({
  open,
  title = 'Confirm Action',
  description = 'Are you sure you want to proceed?',
  confirmText = 'Yes',
  cancelText = 'No',
  onConfirm,
  onCancel,
  iconBgColor = 'bg-red-100 dark:bg-red-900',
  iconColor = 'text-red-600 dark:text-red-400'
}) {

  const [isLoading, setIsLoading] = useState(false);

  const handleConfirm = async () => {
    setIsLoading(true);
    try {
      await onConfirm();
    } finally {
      setIsLoading(false);
    }
  }
    
  return (
    <Dialog open={open} onClose={onCancel} className="relative z-100">
      <DialogBackdrop
        transition
        className="fixed inset-0 bg-gray-500/75 transition-opacity
                   data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200
                   data-[enter]:ease-out data-[leave]:ease-in"
      />

      <div className="fixed inset-0 z-100 w-screen overflow-y-auto">
        <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
          <DialogPanel
            transition
            className="relative transform overflow-hidden rounded-lg bg-white dark:bg-black
                       px-4 pb-4 pt-5 text-left shadow-xl transition-all
                       data-[closed]:translate-y-4 data-[closed]:opacity-0
                       data-[enter]:duration-300 data-[leave]:duration-200
                       data-[enter]:ease-out data-[leave]:ease-in
                       sm:my-8 sm:w-full sm:max-w-lg sm:p-6
                       data-[closed]:sm:translate-y-0 data-[closed]:sm:scale-95"
          >
            <div className="sm:flex sm:items-start">
              <div className={`mx-auto flex size-12 shrink-0 items-center justify-center rounded-full ${iconBgColor} sm:mx-0 sm:size-10`}>
                <ExclamationTriangleIcon aria-hidden="true" className={`size-6 ${iconColor}`} />
              </div>
              <div className="mt-3 text-center sm:ml-4 sm:mt-0 sm:text-left">
                <DialogTitle as="h3" className="text-base font-semibold text-gray-900 dark:text-gray-100">
                  {title}
                </DialogTitle>
                <div className="mt-2">
                  <div className="text-sm text-gray-600 dark:text-gray-400">
                    {description}
                  </div>
                </div>
              </div>
            </div>

            <div className="mt-5 sm:ml-10 sm:mt-4 sm:flex sm:pl-4">
              <button
                type="button"
                onClick={handleConfirm}
                disabled={isLoading}
                className={`inline-flex w-full justify-center rounded-md bg-red-600 dark:bg-red-400 hover:bg-red-500 px-3 py-2 text-sm font-semibold text-white dark:text-black shadow-sm sm:w-auto 
                  ${isLoading ? 'opacity-70 cursor-not-allowed' : ''}`}
              >
                {isLoading ? 'Please wait...' : confirmText}
              </button>
              <button
                type="button"
                onClick={onCancel}
                className="mt-3 inline-flex w-full justify-center rounded-md bg-white dark:bg-black
                           px-3 py-2 text-sm font-semibold text-gray-900 dark:text-gray-100 shadow-sm
                           ring-1 ring-inset ring-gray-300 dark:ring-gray-700
                           hover:bg-gray-50 dark:hover:bg-gray-950 sm:ml-3 sm:mt-0 sm:w-auto"
              >
                {cancelText}
              </button>
            </div>
          </DialogPanel>
        </div>
      </div>
    </Dialog>
  )
}